/* MUHRA — Product page v2 (assets/muhra-pdp.js). Used only by sections/muhra-pdp.liquid. */
(() => {
  if (customElements.get('muhra-pdp')) return;

  const toHandle = (s) => String(s || '').toLowerCase().trim().replace(/['"]/g, '').replace(/[^a-z0-9\u0600-\u06ff]+/g, '-').replace(/^-+|-+$/g, '');

  class MuhraPDP extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-mp-json]');
      if (!json || this.ready) return;
      this.ready = true;
      this.data = JSON.parse(json.textContent);
      this.variants = this.data.variants || [];
      this.labels = this.data.labels || {};
      this.form = this.querySelector('[data-mp-form]');
      this.idInput = this.querySelector('[data-mp-id]');
      this.atc = this.querySelector('[data-mp-atc]');
      this.stickyBtn = this.querySelector('[data-mp-sticky-btn]');
      this.track = this.querySelector('[data-mp-track]');
      this.dots = this.querySelector('[data-mp-dots]');
      this.sticky = this.querySelector('[data-mp-sticky]');
      this.fieldsets = [...this.querySelectorAll('[data-mp-option]')];
      this.selected = this.fieldsets.map((fs) => {
        const checked = fs.querySelector('[data-mp-input]:checked');
        return checked ? checked.value : null;
      });
      if (!document.querySelector('.muhra-size-strip')) {
        this.querySelectorAll('[data-mp-measure]').forEach((b) => { b.hidden = true; });
      }
      this.bindOptions();
      this.bindGallery();
      this.bindBuy();
      this.bindUi();
      this.bindSticky();
      this.bindCountdown();
      this.bindDesktop();
      this.update(false, true);
    }

    /* Desktop: keep the buy column below any sticky/fixed header; stars jump to reviews */
    bindDesktop() {
      const setTop = () => {
        let top = 0;
        document.querySelectorAll('sticky-header, header, .header-wrapper, .section-header').forEach((h) => {
          const cs = getComputedStyle(h);
          if (cs.position === 'sticky' || cs.position === 'fixed') top = Math.max(top, h.getBoundingClientRect().bottom);
        });
        this.style.setProperty('--mp-top', Math.max(0, Math.round(top)) + 24 + 'px');
      };
      setTop();
      window.addEventListener('resize', setTop, { passive: true });
      window.addEventListener('load', setTop, { once: true });
      const stars = this.querySelector('.mp-reviews');
      if (stars) stars.addEventListener('click', () => {
        const w = document.querySelector('.jdgm-review-widget, #judgeme_product_reviews, .jdgm-widget.jdgm-review-widget');
        if (w) w.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* Variants */
    bindOptions() {
      this.addEventListener('change', (e) => {
        const input = e.target.closest('[data-mp-input]');
        if (!input) return;
        const i = Number(input.dataset.optionIndex);
        this.selected[i] = input.value;
        this.update(true, i === this.data.colorIndex);
      });
    }

    findVariant() {
      if (!this.fieldsets.length) return this.variants[0] || null;
      return this.variants.find((v) => v.options.every((o, i) => o === this.selected[i])) || null;
    }

    update(push, refreshGallery) {
      const v = this.findVariant();
      this.variant = v;

      this.fieldsets.forEach((fs, i) => {
        const label = fs.querySelector('[data-mp-selected]');
        if (label) label.textContent = this.selected[i] || '';
        fs.querySelectorAll('[data-mp-input]').forEach((input) => {
          const ok = this.variants.some((x) => x.available && x.options[i] === input.value && x.options.every((o, j) => j === i || o === this.selected[j]));
          const lbl = fs.querySelector('label[for="' + input.id + '"]');
          if (lbl) lbl.classList.toggle('is-soldout', !ok);
        });
      });

      if (v) {
        this.idInput.value = String(v.id);
        this.renderPrice(v);
        this.setAtc(v.available ? 'add' : 'soldout');
        const sku = this.querySelector('[data-mp-sku]');
        if (sku) sku.textContent = v.sku || '';
        if (push) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        }
      } else {
        this.setAtc('unavailable');
      }

      if (refreshGallery) this.filterGallery(v);
      this.dispatchEvent(new CustomEvent('muhra:variant-change', { bubbles: true, detail: { variant: v } }));
    }

    renderPrice(v) {
      let html = '<span class="mp-price__now">' + v.price + '</span>';
      if (v.compare) html += '<s class="mp-price__was">' + v.compare + '</s><span class="mp-price__save">-' + v.save + '%</span>';
      this.querySelectorAll('[data-mp-price]').forEach((el) => { el.innerHTML = html; });
      const sp = this.querySelector('[data-mp-sticky-price]');
      if (sp) sp.textContent = v.priceText;
    }

    setAtc(state) {
      const text = this.labels[state] || state;
      const disabled = state !== 'add';
      [this.atc, this.stickyBtn].forEach((b) => {
        if (!b) return;
        b.disabled = disabled;
        const t = b.querySelector('[data-mp-label]') || b;
        t.textContent = text;
      });
    }

    /* Gallery */
    filterGallery(v) {
      if (!this.track) return;
      const slides = [...this.track.querySelectorAll('[data-mp-slide]')];
      const ci = this.data.colorIndex;
      if (ci > -1 && this.selected[ci]) {
        const h = toHandle(this.selected[ci]);
        const match = (s) => {
          const a = s.dataset.alt || '';
          return a === h || a.indexOf(h + '-') === 0;
        };
        const any = slides.some((s) => !s.hasAttribute('data-mp-always') && match(s));
        slides.forEach((s) => {
          s.hidden = any && !s.hasAttribute('data-mp-always') && !match(s);
        });
      }
      this.visible = slides.filter((s) => !s.hidden);
      if (this.dots) {
        this.dots.innerHTML = this.visible.length > 1 ? this.visible.map(() => '<span class="mp-dot"></span>').join('') : '';
      }
      let target = this.visible[0];
      if (v && v.media) {
        const m = this.visible.find((s) => s.dataset.mediaId === String(v.media));
        if (m) target = m;
      }
      if (target && this.track.scrollWidth > this.track.clientWidth) {
        this.track.scrollTo({ left: target.offsetLeft, behavior: 'auto' });
      }
      this.setIndex(Math.max(0, this.visible.indexOf(target)));
    }

    setIndex(i) {
      this.index = i;
      if (this.dots) [...this.dots.children].forEach((d, j) => d.classList.toggle('is-active', j === i));
    }

    bindGallery() {
      if (!this.track) return;
      let raf = 0;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          if (!this.visible) return;
          const x = this.track.scrollLeft;
          let best = 0;
          let dist = Infinity;
          this.visible.forEach((s, i) => {
            const d = Math.abs(s.offsetLeft - x);
            if (d < dist) { dist = d; best = i; }
          });
          if (best !== this.index) this.setIndex(best);
        });
      }, { passive: true });

      this.track.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-mp-play]');
        if (!btn) return;
        const slide = btn.closest('[data-mp-slide]');
        const tpl = slide && slide.querySelector('template');
        if (!tpl) return;
        btn.replaceWith(tpl.content.cloneNode(true));
        const video = slide.querySelector('video');
        if (video) {
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        }
      });
    }

    playVideo() {
      if (!this.track) return;
      const slide = this.track.querySelector('[data-mp-video]:not([hidden])');
      if (!slide) return;
      if (this.track.scrollWidth > this.track.clientWidth) {
        this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      } else {
        slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      const play = slide.querySelector('[data-mp-play]');
      if (play) {
        play.click();
      } else {
        const v = slide.querySelector('video');
        if (v) { const pr = v.play(); if (pr && pr.catch) pr.catch(() => {}); }
      }
    }

    /* Cart */
    bindBuy() {
      const qty = this.querySelector('[data-mp-qty-input]');
      this.querySelectorAll('[data-mp-qty]').forEach((b) => {
        b.addEventListener('click', () => {
          if (!qty) return;
          qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.mpQty, 10));
        });
      });
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    busy(on) {
      [this.atc, this.stickyBtn].forEach((b) => {
        if (!b) return;
        b.setAttribute('aria-busy', on ? 'true' : 'false');
        const t = b.querySelector('[data-mp-label]') || b;
        t.textContent = on ? this.labels.adding : this.labels.add;
      });
    }

    showError(msg) {
      const el = this.querySelector('[data-mp-error]');
      if (!el) return;
      el.textContent = msg || '';
      el.hidden = !msg;
    }

    async onSubmit(e) {
      e.preventDefault();
      if (!this.variant || !this.variant.available || this.atc.getAttribute('aria-busy') === 'true') return;
      this.showError('');
      this.busy(true);
      const cart = document.querySelector('cart-drawer');
      const fd = new FormData(this.form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
        fd.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const hasPubSub = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
      let failed = false;
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        });
        const data = await res.json();
        if (data.status) {
          failed = true;
          this.showError(data.description || data.message || this.labels.error);
          if (hasPubSub) publish(PUB_SUB_EVENTS.cartError, { source: 'muhra-pdp', productVariantId: fd.get('id'), errors: data.errors || data.description, message: data.message });
          return;
        }
        if (!cart || typeof cart.renderContents !== 'function') {
          window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
          return;
        }
        if (hasPubSub) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'muhra-pdp', productVariantId: fd.get('id'), cartData: data });
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } catch (err) {
        failed = true;
        this.showError(this.labels.error);
        console.error(err);
      } finally {
        this.busy(false);
        if (failed) this.setAtc(this.variant && this.variant.available ? 'add' : 'soldout');
      }
    }

    /* Drawer, promo code, share, video button */
    bindUi() {
      this.addEventListener('click', (e) => {
        const open = e.target.closest('[data-mp-open]');
        if (open) {
          const d = this.querySelector('[data-mp-drawer="' + open.dataset.mpOpen + '"]');
          if (d && typeof d.showModal === 'function') {
            d.showModal();
            document.documentElement.classList.add('mp-lock');
          }
          return;
        }
        if (e.target.tagName === 'DIALOG') { e.target.close(); return; }
        if (e.target.closest('[data-mp-video-go]')) { this.playVideo(); return; }
        const close = e.target.closest('[data-mp-close]');
        if (close) { close.closest('dialog').close(); return; }
        const measure = e.target.closest('[data-mp-measure]');
        if (measure) {
          const d = measure.closest('dialog');
          if (d) d.close();
          const strip = document.querySelector('.muhra-size-strip');
          if (strip) strip.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        const copy = e.target.closest('[data-mp-copy]');
        if (copy) { this.copy(copy.dataset.mpCopy, copy); return; }
        const share = e.target.closest('[data-mp-share]');
        if (share) {
          if (navigator.share) navigator.share({ title: document.title, url: this.data.url }).catch(() => {});
          else this.copy(this.data.url, share);
        }
      });
      this.querySelectorAll('dialog').forEach((d) => {
        d.addEventListener('close', () => document.documentElement.classList.remove('mp-lock'));
      });
    }

    copy(text, el) {
      if (el.hasAttribute('data-mp-icon')) {
        const flag = () => {
          el.classList.add('is-copied');
          clearTimeout(el._mpT);
          el._mpT = setTimeout(() => el.classList.remove('is-copied'), 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(flag, () => {});
        return;
      }
      const done = () => {
        const original = el.dataset.mpText || el.textContent;
        el.dataset.mpText = original;
        el.textContent = this.labels.copied;
        clearTimeout(el._mpT);
        el._mpT = setTimeout(() => { el.textContent = original; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, () => {});
    }

    /* Sticky add to cart: appears once the main button scrolls out of view */
    bindSticky() {
      if (!this.sticky || !this.atc || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.sticky.classList.toggle('is-visible', show);
        this.sticky.toggleAttribute('inert', !show);
      });
      io.observe(this.atc);
      if (this.stickyBtn) {
        this.stickyBtn.addEventListener('click', () => {
          if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit();
          else this.form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
    }

    bindCountdown() {
      const el = this.querySelector('[data-mp-countdown]');
      if (!el) return;
      const end = Date.parse(el.dataset.end);
      const out = el.querySelector('time');
      if (isNaN(end) || !out) { el.hidden = true; return; }
      const pad = (n) => String(n).padStart(2, '0');
      let timer = 0;
      const tick = () => {
        let s = Math.floor((end - Date.now()) / 1000);
        if (s <= 0) { el.hidden = true; clearInterval(timer); return; }
        const d = Math.floor(s / 86400); s %= 86400;
        const h = Math.floor(s / 3600); s %= 3600;
        const m = Math.floor(s / 60); s %= 60;
        out.textContent = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      };
      tick();
      el.hidden = false;
      timer = setInterval(tick, 1000);
    }
  }

  customElements.define('muhra-pdp', MuhraPDP);
})();